import { apiClient } from './apiClient';
import { apiGuestClient } from './apiGuestClient';
import { ts_hocsinh_lichsu_yte_khothuoc } from '../models/response/category/ts_hocsinh_lichsu_yte_khothuoc';

const KHO_THUOC_API_END_POINT = 'kho-thuoc';

export const khoThuocApi = {
    // Lấy tồn kho
    selectTonKho: () => apiGuestClient.get(`${KHO_THUOC_API_END_POINT}/ton-kho`),

    // Lấy tất cả lịch sử
    selectAllLichSu: () => apiGuestClient.get(`${KHO_THUOC_API_END_POINT}/lich-su`),

    // Lấy lịch sử theo loại thuốc
    selectLichSuByLoaiThuoc: (loaiThuocId: number) => apiGuestClient.get(`${KHO_THUOC_API_END_POINT}/lich-su/${loaiThuocId}`),

    // Lấy tất cả kho thuốc
    selectAll: () => apiGuestClient.get(`${KHO_THUOC_API_END_POINT}`),

    // Lấy chi tiết kho thuốc theo ID
    detail: (id: number) => apiClient.get(`${KHO_THUOC_API_END_POINT}/${id}`),

    // Thêm mới giao dịch kho thuốc
    insert: (data: ts_hocsinh_lichsu_yte_khothuoc) => apiClient.post(`${KHO_THUOC_API_END_POINT}`, data),

    // Cập nhật giao dịch kho thuốc
    update: (data: ts_hocsinh_lichsu_yte_khothuoc) => apiClient.put(`${KHO_THUOC_API_END_POINT}/${data.id}`, data),

    // Xóa giao dịch kho thuốc
    delete: (id: number) => apiClient.delete(`${KHO_THUOC_API_END_POINT}/${id}`),

    // Export to template function
    exportToTemplate: (request: {
        nam_hoc: string,
        dm_coso_id: number
    }) => {
        const url = `${KHO_THUOC_API_END_POINT}/export-template/nam-hoc/${request.nam_hoc}/co-so/${request.dm_coso_id}`;
        return apiGuestClient.get(url);
    }
};
